/**
 * Zone enums
 */

export enum ZONE_NAME {
  LOG_CONTEXT = 'LogContext',
}

export enum ZONE_PROPERTY_NAME {
  LOG_ACTION_CONTEXT = 'logActionContext',
  CID = 'cid',
  LOCKER = 'locker',
}
